<template>
	<div>
		<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
			<vs-icon
				icon-pack="feather"
				icon="icon-more-horizontal"
				size="1.2rem"
				class="cursor-pointer"
				:aria-label="$t('Actions pour cette entreprise')"
			/>

			<vs-dropdown-menu>
				<div class="apps_container">
					<div
						:disabled="app.loading_apikey"
						class="dropdown-item px-2 py-1"
						:class="{ 'pointer-events-none opacity-50': !user?.partner_id || !loadedCollaborators }"
						@click="copyApikey(app)"
					>
						<vs-icon icon-pack="feather" icon="icon-link" size="1.2rem" class="mr-2" />
						{{ $t("Copier la clé Api-Key") }}
					</div>

					<hr class="mx-5 my-2" />

					<div
						class="dropdown-item px-2 py-1"
						:class="{ 'pointer-events-none opacity-50': !user?.partner_id || !loadedCollaborators }"
						@click="openModal('Comptable', app)"
					>
						<vs-icon icon-pack="feather" icon="icon-user" size="1.2rem" class="mr-2" />
						{{ $t("Affecter un comptable") }}
					</div>

					<div
						class="dropdown-item px-2 py-1"
						:class="{ 'pointer-events-none opacity-50': !loadedCollaborators }"
						@click="openModal('Support technique', app)"
					>
						<vs-icon icon-pack="feather" icon="icon-headphones" size="1.2rem" class="mr-2" />
						{{ $t("Affecter un support") }}
					</div>
				</div>
			</vs-dropdown-menu>
		</vs-dropdown>

		<div v-if="selectedRole && selectedApp">
			<ModalAssignCompaniesToCollaborators
				:visible="showModal"
				:apps="[selectedApp]"
				:filtered-collaborators="getFilteredCollaborators()"
				:partner-id="
					user?.partner_id ??
					user?.collaborator_partner_id ??
					loadedCollaborators.find(collaborator => collaborator.user_id === user.id)?.partner_id
				"
				@close="changeModalState(false)"
				@update="() => {}"
				@update:visible="val => changeModalState(val)"
			/>
		</div>
	</div>
</template>

<script>
	import i18n from "@/i18n";
	import { mapState } from "vuex";
	import ModalAssignCompaniesToCollaborators from "@/components/ModalAssignCompaniesToCollaborators.vue";

	export default {
		name: "DropdownActionsCases",
		components: { ModalAssignCompaniesToCollaborators },
		props: {
			app: {
				type: Object,
				default: () => {}
			}
		},
		data() {
			return {
				showModal: false,
				selectedRole: null,
				selectedApp: null
			};
		},
		computed: {
			...mapState(["user", "loadedPolicies", "loadedCollaborators"])
		},
		methods: {
			async copyApikey(app) {
				if (app.loading_apikey) return;

				if (app.last_asked_apikey && new Date() - app.last_asked_apikey < 5000) {
					this.$vs.notify({
						text: this.$t("Veuillez patienter quelques secondes avant de demander une nouvelle clé"),
						color: "warning",
						time: 5000
					});
					return;
				}

				app.loading_apikey = true;
				try {
					const { token } = await this.$store.dispatch("getApikey", {
						partnerId: this.user?.partner_id,
						app_id: app.id
					});

					navigator.clipboard.writeText(token);

					this.$vs.notify({
						text: i18n.t("La clé ’Api-Key’ a été copiée avec succès"),
						color: "success",
						time: 5000
					});
				} catch (err) {
					console.log(err.response?.data?.message || err);
					this.$vs.notify({
						text: i18n.t(err.response?.data?.message || "Erreur lors de la génération de la clé."),
						color: "danger",
						time: 5000
					});
				} finally {
					app.loading_apikey = false;
					app.last_asked_apikey = new Date();
				}
			},
			openModal(role, app) {
				this.selectedRole = role;
				this.selectedApp = app;
				this.showModal = true;
			},
			changeModalState(val) {
				this.showModal = val;
				this.selectedRole = null;
			},
			getFilteredCollaborators() {
				if (this.user?.partner_id == null && this.user?.collaborator_partner_id !== null) {
					return this.loadedCollaborators.filter(collaborator => collaborator.user_id === this.user?.id);
				} else {
					return this.loadedCollaborators.filter(
						collaborator => collaborator.policy_profile.name === this.selectedRole
					);
				}
			}
		}
	};
</script>

<style scoped>
	.apps_container {
		max-height: 40vh;
		overflow: scroll;
		min-width: fit-content;
	}

	.selector_button {
		padding: 0.4rem 0.6rem;
	}

	.dropdown-item {
		cursor: pointer;
	}
	.dropdown-item:hover {
		background-color: var(--border);
	}
</style>
